module.exports = __webpack_public_path__ + "media/logos/xconomy-logo-white-13f97fc3.png";